module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_sharp_right.91c2431c.png";